<!-- 上课单词 复习-->
<template>

    <el-row class="main-box" :gutter="30" >
				<el-col class="listdivcls " :offset="7" :span="9">
					<div style="font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
						学前检测</div>
					<div  class="itembgcls flex-row f-align-center" v-for="(itemdata, indexdata) in datalist" :key="indexdata" >
						<div style="margin-left: 13px;text-align: start;">{{indexdata+1}}</div>
						<div class="flex1 flex-colmun f-justify-center" style="margin-left: 13px;text-align: start;" @click="requsturl(itemdata.id)">
							{{itemdata.word}}
						</div>
						<div  class="chinesecls" @click="showchinese(indexdata)">
							{{showindex==indexdata?itemdata.chinese:''}}
						</div>
						<img  class="imagwh" style="margin-right: 6px;" mode="fill" v-on:mouseover="addzq(indexdata)" @click="addzq1(indexdata)"  :src="itemdata.isGrasp==1? require('@/static/jd_check1_1.png'):require('@/static/jd_check1_0.png')"/>
						<img class="imagwh" style="margin-right: 13px;" mode="fill"  v-on:mouseover="addcw(indexdata)" @click="addcw1(indexdata)"  :src="itemdata.isGrasp==0?require('@/static/jd_check2_1.png'):require('@/static/jd_check2_0.png')"/>
					</div>
				</el-col>
				<el-col :span="4">
					<div class="xcls flex-column " style="position: fixed;width: 13%;"> 
						<div class="dccls flex-row f-center" style="margin-top: 20px;">
							<span class="text11">全部</span>
							<span class="text12" style="margin-left: 10px;margin-right: 5px;">{{datalist.length}}</span>
							<span class="text13">单词</span>
						</div>
						<div class="flex-row f-center" style="margin-top: 20px;">
							<span class="text14">正确</span>
							<span class="text16" style="color: #0AA26B;">{{zqnum}}</span>
							<div  class="text17" ></div>
							<span class="text15">待学</span>
							 <span class="text16" style="color: #F4CB22;">{{cwnum}}</span>
						</div>
						<div class="bucls1" @click="sumclick()" style="margin-top:21px ;">
							提交
						</div>
						<div class="bucls2" @click="finish()" style="margin-top:21px ;">
							返回
						</div>
					</div>
				</el-col>
				
				<audio  playbackRate='1.2'  ref="audio">
					<source :src="playsrc" type="audio/mp3"/>
				</audio>
    </el-row>
	

</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Loading } from 'element-ui';
export default {
    data() {
        return {
			datalist:[
			],
			planId:"",
			recordId:"",
			courseId:"",
			studentId:"",
			zqnum:0,
			cwnum:0,
			playsrc:"",
			isplay:false,
			showindex:-1,
			timer: null,//
			pageNum:1,
			pageSize:100,
			onFetching:false,
			isrequsting:false,
			}
    },
    computed: {
      ...mapState([
          'userToken',
		   'userInfos',
      ]),
      ...mapGetters(["getUserToken"])
    },
	created() {
		this.courseId = decodeURIComponent(this.$route.query.courseId)
		this.planId = decodeURIComponent(this.$route.query.planId)
		this.studentId = decodeURIComponent(this.$route.query.studentId)
		this.countdown = decodeURIComponent(this.$route.query.countdown)
	    this.getdata();
	},
	mounted(){
	  window.addEventListener('scroll', this.handleScroll)
	},
	beforeDestroy(){
	  window.removeEventListener('scroll', this.handleScroll, false);
	},
    methods: {
		handleScroll(){
			  // 变量scrollTop是滚动条滚动时，距离顶部的距离
			  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			  // 变量windowHeight是可视区的高度
			  var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
			  // 变量scrollHeight是滚动条的总高度
			  var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
			  console.log("~~~~~~~~~~"+scrollTop + windowHeight - scrollHeight);
			  // 滚动条到底部的条件
			  if (scrollTop + windowHeight - scrollHeight>-10) {
			    if (!this.onFetching) {
			      this.pageNum += 1 // 页数+1
			        // 重新加载数剧
			        this.getdata()
			    }
			  }
			},
		showchinese(index){
			this.showindex=index;
			this.clearTimer();
			 this.timer = setTimeout(() => {
			  this.showindex=-1;
			  }, 2000);
		},
		async requsturl(id){
			if(this.isplay)
			{
				return;
			}
			this.isplay=true;
			 let res = await this.$api.get("/web/teacher/home/selectWordPronunciation", {
			        headers: { //头部参数
			            frontUserToken: this.getUserToken
			        },
					params:{
						id :id,
					 }
			    });
				this.isplay=false;
				if(res.code==200)
				{
					this.play(res.data.pronunciation);
				}
		},
		clearTimer () {
		    this.timer && clearInterval(this.timer)
		 },
		play(url)
		{
			this.playsrc=url;
			let music1 = new Audio();
			 music1 = url;
			 this.$refs.audio.src = music1;
			 let audioPlayer = this.$refs.audio;
			 audioPlayer.playbackRate = 1.2;
			this.$refs.audio.play();
		},
		addzq(index){
			if(this.datalist[index].isGrasp==1)
			{
				return;
			}
			
			if(this.datalist[index].isGrasp==0)
			{
				this.cwnum--;
			}
			this.datalist[index].isGrasp=1;
			this.zqnum++;
		},
		addcw(index){
			if(this.datalist[index].isGrasp==0)
			{
				return;
			}
			
			if(this.datalist[index].isGrasp==1)
			{
				this.zqnum--;
			}
			this.datalist[index].isGrasp=0;
			this.cwnum++;
		},
		addzq1(index){
			if(this.datalist[index].isGrasp==1)
			{
				this.datalist[index].isGrasp=null;
				this.zqnum--;
				return;
			}
			
			if(this.datalist[index].isGrasp==0)
			{
				this.cwnum--;
			}
			this.datalist[index].isGrasp=1;
			this.zqnum++;
		},
		addcw1(index){
			if(this.datalist[index].isGrasp==0)
			{
				this.datalist[index].isGrasp=null;
				this.cwnum--;
				return;
			}
			
			if(this.datalist[index].isGrasp==1)
			{
				this.zqnum--;
			}
			this.datalist[index].isGrasp=0;
			this.cwnum++;
		},
		async sumclick(){
			
			if(this.isrequsting)
			{
				return;
			}
			this.isrequsting=true;
			var requstdata=this.datalist.filter((p)=>{
			                        return p.isGrasp!=null
			                    });
			let res = await this.$api.post("/web/teacher/attendClass/learnWordDataSubmit",{
				courseId:this.courseId,
				learnWordDetailVos:requstdata,
				planId:this.planId,
				recordId:this.recordId,
			} ,{
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    }
			});
			if(res.code==200)
			{
				this.$message({
				  type: "success",
				  message: "提交成功"
				});
				
				var data=res.data;
				
				if(data==null||data.learnWordDetailVos==null||data.learnWordDetailVos.length==0)
				{
					this.$router.back();
					return;
				}
				this.recordId=data.recordId;
				this.$router.replace({
					name: "attend_class_list2",
					params:{
					courseId:this.courseId,
					recordId:this.recordId,
					countdown:this.countdown,
					data:res.data.learnWordDetailVos,
					}
				});
				this.isrequsting=false;
			}else{
					this.isrequsting=false;
				this.$message({
				  type: "warning",
				  message: res.msg
				});
			}
		},
		 finish(){
			this.$router.back();
		 },
		async getdata() {
				this.onFetching=true;
		    let res = await this.$api.get("/web/teacher/attendClass/learnWordData", {
		        headers: { //头部参数
		            frontUserToken: this.getUserToken
		        },
				params:{
					courseId:this.courseId,
					studentId:this.studentId,
					pageNum:this.pageNum,
					pageSize:this.pageSize,
				 }
		    });
			
			
			this.onFetching=false;
			if(res.code==200)
			{
				
				if(this.pageNum==1){
					if(res.rows==null||res.rows.length<=0)
					{
						this.$message({
							  type: "success",
							  message: "该课程已学完请复习!"
							});
						this.$router.back();
						return;
					}
					this.datalist=res.rows;
				}else{
					this.datalist.push(...res.rows);
				}
			}
		},
    }
}
</script>

<style lang="scss" scoped>
.main-box {
    width: 100%;
	flex: 1;
    background: #B6E4D3;
    position: relative;
	padding-top: 84px;
	
	.listdivcls{
	  border-radius: 20px;
	  background: #E5F3F1;
	  padding-top: 21px;
	    padding-bottom: 21px;
	  font-family: Oswald;
	  font-size: 30px;
	  font-weight: normal;
	  line-height: normal;
	  text-align: center;
	  letter-spacing: 0em;
	  font-feature-settings: "kern" on;
	  /* 绿 */
	  color: #0AA26B;
	  
	 @media screen and (max-width: 1400px)  {
	  	  font-size: 25px;
	  }
	  
	  @media screen and (max-width: 1000px)  {
	   	  font-size: 18px;
	   }
	}
	
	.chinesecls{
		width: 27%;
		height: 100%;
		line-height: 80px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	
	
	.itembgcls{
		overflow: hidden;
		cursor: pointer;
		/* 矩形 55 */
		margin-left: 30px;
		margin-right: 30px;
		height: 80px;
		border-radius: 20px;
		opacity: 1;
		margin-top: 23px;
		/* 纯白 */
		background: #FFFFFF;
		box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);
		
		.imagwh{
			width: 35px;
			height: 35px;
			
			 @media screen and (max-width: 1400px)  {
				width: 25px;
				height: 25px;
			}
			
			@media screen and (max-width: 1000px)  {
				width: 10px;
				height: 10px;
			}
		}
	}
	
	.xcls{
		height: 307px;
		border-radius: 20px;
		opacity: 1;
		overflow: hidden;
		background: #FFFFFF;
		
		
		.dccls{
			margin-left: 15px;
			margin-right: 15px;
			height: 76px;
			border-radius: 20px;
			opacity: 1;
			background: linear-gradient(330deg, #FFFFFF 14%, #D9F1E5 77%);
			box-shadow: 0px 0px 10px 0px rgba(145, 170, 158, 0.1);
	
		}
		
		.text11{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: 30px;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 已选择 */
			font-family: 思源黑体;
			font-weight: 400;
			font-size: 18;
			color: #ACBEB0;
			
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
			  }
		}
		
		.text12{
			font-family: Oswald;
			font-size: 36px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
			
			@media screen and (max-width: 1400px)  {
			 	  font-size: 20px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 10px;
			  }
		}
		
		.text13{
			font-weight: normal;
			line-height: 30px;
			letter-spacing: 0em;
			font-family: Source Han Sans;
			font-weight: 400;
			font-size: 18px;
			color: #333333;
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
			  }
		}
		
		
		.text14{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
			
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
			  }
		}
		
		.text15{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 红 */
			color: #F4CB22;
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
			  }
		}
		
		.text16{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			margin-left: 19px;
			font-feature-settings: "kern" on;
		
			
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
				  margin-left: 10px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
				  margin-left: 8px;
			  }
		}
		
		
		.text17{
			width: 10%;
			
		
		}
		
		.bucls1{
			margin-left: 15px;
			margin-right: 15px;
			 cursor: pointer;
			height: 46px;
			border-radius: 100px;
			opacity: 1;
			text-align: center;
			/* 绿 */
			background: #0AA26B;
			font-family: 思源黑体;
			font-size: 18px;
			font-weight: bold;
			line-height: 46px;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 纯白 */
			color: #FFFFFF;
		}
		
		.bucls2{
			margin-left: 15px;
			margin-right: 15px;
			 cursor: pointer;
			height: 46px;
			border-radius: 100px;
			opacity: 1;
			
			box-sizing: border-box;
			/* 绿 */
			border: 2px solid #0AA26B;
			text-align: center;
			font-family: 思源黑体;
			font-size: 18px;
			font-weight: normal;
			line-height: 46px;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
		}
	}
	
	.appraise-popup-title {
	    width: 100%;
	    height: 86px;
	    border-radius: 20px 20px 0 0;
	    background: #0AA26B;
	    box-sizing: border-box;
	    padding: 0 35px;
	
	    .appraise-popup-title-name {
	        font-family: 思源黑体;
	        font-size: 26px;
	        font-weight: bold;
	        line-height: normal;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 纯白 */
	        color: #FFFFFF;
	    }
	
	    img {
	        width: 56px;
	        height: 56px;
	    }
	}
	.start-popup-content {
	    background: #fff;
	    border-radius: 0 0 20px 20px;
	    box-sizing: border-box;
	    padding: 0 52px;
	
	    .start-popup-content-text1 {
	        margin-left: 173.5px;
	        margin-top: 89px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 333333 */
	        color: #333333;
	    }
	
	    .start-popup-content-timebox {
	        margin-top: 30px;
	        margin-left: 173.5px;
	
	        span {
	            margin-right: 30px;
	            font-family: 思源黑体;
	            font-size: 22px;
	            font-weight: normal;
	            line-height: 30px;
	            letter-spacing: 0em;
	
	            font-feature-settings: "kern" on;
	            /* 333333 */
	            color: #333333;
	        }
	
	        div {
	            width: 195px;
	            height: 64px;
	            border-radius: 100px;
	            opacity: 1;
	
	            background: #E5F7F1;
	
	            box-sizing: border-box;
	            border: 1px solid rgba(10, 162, 107, 0.2);
	        }
	
	    }
	
	    .start-popup-content-tipsbox {
	        margin-top: 89px;
	        margin-bottom: 75px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 确认开始学员 */
	        color: #333333
	    }
	
	    .start-popup-content-line {
	        margin-top: 30px;
	        width: 100%;
	        height: 0px;
	        opacity: 1;
	
	        border: 1px solid rgba(10, 162, 107, 0.2);
	    }
	
	    .start-popup-content-btnsbox {
	        margin-top: 31px;
	        margin-bottom: 30px;
	
	        div {
	            &:first-child {
	                margin-right: 20px;
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 灰 */
	                background: #ACBEB0;
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	
	            &:last-child {
	
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 绿 */
	                background: #0AA26B;
	
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	        }
	    }
	
	}
	
}



/deep/ .el-dialog__header {
    border-radius: 20px 20px 0 0;
    padding: 0;

}

/deep/ .el-dialog__body {
    border-radius: 20px;
    padding: 0;
}

/deep/ .el-dialog {
    background: transparent;
    border-radius: 20px;
    box-shadow: 0 0px 0px #ccc;

    @media screen and (min-width: 992px) {
        width: 44.114%;
    }

    @media screen and (max-width: 991px) and (min-width: 768px) {
        width: 82.395%;
    }

    @media screen and (max-width: 767px) {
        width: 100%;
    }




}
</style>